import * as React from 'react';
import { useCreateImportFolderMutation, useUpdateImportFolderMutation } from '../../../../models/graphql';
import { useCallback, useContext } from 'react';
import { AppContext } from '../../../../providers/AppProvider';
import { AddEditFolderModalProps, AddEditFolderModalView } from './AddEditFolderModal.view';
import { TreeMenuContext } from '../TreeMenu/TreeMenuProvider';
import { gql } from '@apollo/client';

gql`
  mutation CreateImportFolder($workspaceId: ID!, $input: CreateImportFolderInput!) {
    createImportFolder(workspaceId: $workspaceId, input: $input) {
      ...CoreImportFolderFields
      importSources {
        ...ImportSourceFields
      }
    }
  }
`;

export const AddEditFolderModalApollo = (): JSX.Element => {
  const { selectedWorkspaceId } = useContext(AppContext);
  const { reFetchTreeMenu } = useContext(TreeMenuContext);
  const [createImportFolder] = useCreateImportFolderMutation();
  const [updateImportFolder] = useUpdateImportFolderMutation();

  const addFolderHandler = useCallback(
    async (name: string) => {
      if (!selectedWorkspaceId) return;
      await createImportFolder({
        variables: { workspaceId: selectedWorkspaceId, input: { name: name } },
        update: () => {
          reFetchTreeMenu();
        }
      });
    },
    [createImportFolder, reFetchTreeMenu, selectedWorkspaceId]
  );

  const updateFolderHandler = useCallback(
    async (id: string, name: string) => {
      if (!selectedWorkspaceId) return;

      await updateImportFolder({
        variables: { importFolderId: id, input: { name: name } },
        update: () => {
          reFetchTreeMenu();
        }
      });
    },
    [reFetchTreeMenu, selectedWorkspaceId, updateImportFolder]
  );

  const viewProps: AddEditFolderModalProps = {
    addFolderHandler,
    updateFolderHandler
  };

  return <AddEditFolderModalView {...viewProps} />;
};
